export const DEV_PORT = import.meta.env.VITE_DEV_PORT ? Number(import.meta.env.VITE_DEV_PORT) : 8080;
export const APP_URL = window.Xavier.config.appUrl || 'http://localhost:8000';
